import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 17v-4l-5 3l-5 -3v4l5 3l5 -3","key":"svg-0"}],["path",{"d":"M17 8v-4l-5 3l-5 -3v4l5 3l5 -3","key":"svg-1"}]]

/**
 * IconBadges
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYmFkZ2VzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNyAxN3YtNGwtNSAzbC01IC0zdjRsNSAzbDUgLTMiIC8+CiAgPHBhdGggZD0iTTE3IDh2LTRsLTUgM2wtNSAtM3Y0bDUgM2w1IC0zIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/badges
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBadges = createReactComponent('outline', 'badges', 'Badges', __iconNode);

export default IconBadges;